import _ from "lodash";

export interface User {
  name: string;
  position: string;
  photo: string;
  email: string;
  phone: string;
  department: string;
  location: string;
  joinedDate: string;
  manager: string;
  addressLine1: string;
  addressLine2: string;
  isActive: boolean;
  channel: string;
  status: string;
}

const imageAssets = import.meta.glob<{
  default: string;
}>("/src/assets/images/users/*.{jpg,jpeg,png,svg}", { eager: true });

const fakers = {
  fakeUsers() {
    const users: Array<User> = [
      {
        name: "Ian Mullane",
        position: "Super Admin",
        photo: imageAssets["/src/assets/images/users/icon-user.jpg"].default,
        email: "ian@keepme.club",
        phone: "+44 1234 5678",
        department: "Sales",
        location: "United Kingdom",
        joinedDate: "20 Jul 2024",
        manager: "Palm",
        addressLine1: "123 Main Street",
        addressLine2: "Suite 456",
        isActive: true,
        channel: "Facebook",
        status: "Tour",
      },
    ];

    return _.shuffle(users);
  },
};

export default fakers;
